module.exports = __webpack_public_path__ + "static/img/4.8dcd0c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/9/zh/4.png
// module id = poMG
// module chunks = 0